import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { map } from 'lodash/fp';
import { Table as MuiTable, TableHead, TableBody } from '@material-ui/core';

const S = {
  Col: styled.col`
    ${({ overriding }) => overriding};
  `,
};

/**
 * Table을 사용하면 한 눈에 보기 좋은 형태로 데이터를 표현할 수 있으므로 사용자는 정보를 쉽게 식별할 수 있습니다.
 *
 * @version 1.0.0
 * @author [chayeoi](https://github.com/chayeoi)
 */

const Table = ({
  cols,
  head,
  body,
  tableRow: TableRow,
  tableCell: TableCell,
}) => (
  <MuiTable>
    {cols && (
      <colgroup>
        {map(col => <S.Col key={col.id} overriding={col.style} />, cols)}
      </colgroup>
    )}
    {head && (
      <TableHead>
        <TableRow variant="head">
          {map(cell => <TableCell key={cell.id} variant="head">{cell.content}</TableCell>, head.cells)}
        </TableRow>
      </TableHead>
    )}
    {body && (
      <TableBody>
        {map((row) => {
          const rowProps = row.props || {};

          return (
            <TableRow
              key={row.id}
              hover
              variant={row.group ? 'group' : ''}
              {...rowProps}
            >
              {map((cell) => {
                const cellProps = cell.props || {};

                return (
                  <TableCell
                    key={cell.id}
                    active={row.active}
                    style={cell.style}
                    {...cellProps}
                  >
                    {cell.content}
                  </TableCell>
                );
              }, row.cells)}
            </TableRow>
          );
        }, body.rows)}
      </TableBody>
    )}
  </MuiTable>
);

Table.propTypes = {
  cols: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    style: PropTypes.arrayOf(PropTypes.string),
  })),
  head: PropTypes.shape({
    id: PropTypes.string.isRequired,
    cells: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      content: PropTypes.node.isRequired,
    })).isRequired,
  }),
  body: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      cells: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        content: PropTypes.node.isRequired,
      })).isRequired,
      active: PropTypes.bool,
    })),
  }),
  tableRow: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  tableCell: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
};

Table.defaultProps = {
  cols: null,
  head: null,
  body: null,
};

export default Table;
